(() => {
  if (window.theme?.pageType === 'product') {
    return;
  }

  document.body.addEventListener('click', (e) => {
    const isDisabledOptionClicked = e.target.closest(
      '[data-option-buttons] button.disabled'
    );

    const productURL = e.target
      .closest('[js-product-url]')
      ?.getAttribute('js-product-url');

    if (!isDisabledOptionClicked || !productURL) {
      return;
    }

    setTimeout(() => {
      const currentParams = new URLSearchParams(window.location.search);
      const selectedVariantID = currentParams.get('variant');

      const endpoint = new URL(window.location);
      const params = new URLSearchParams(endpoint);

      params.set('variant', selectedVariantID);
      endpoint.pathname = productURL;
      endpoint.search = params.toString();

      window.location.href = endpoint.href;
    }, 50);
  });
})();
